// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Default_wrapper__JEPNI","radio":"Default_radio__5v6t1","fakeRadio":"Default_fakeRadio__lYTjh","error":"Default_error__MutU2"};